import service from '@/services/docMailer'
import { login } from '@/util/apiLogin'

export const actions = {
  enviarDocumentos: async ({}, docs) => {
    await login()
    return service.enviarDocumentos(docs)
  },
  downloadPDF: async ({}, doc) => {
    await login()
    return service.downloadPDF(doc)
  },
  reenviarDocumentoOtroCorreo: async ({}, { doc, emails }) => {
    await login()
    return service.reenviarDocumentoOtroCorreo(doc, emails)
  }
}
